import { GetCodigoFechaActual } from 'sigo-package'
import { DtoResponseSelectStockPersonal } from '../../../../Master/Home/Domain/DtoResponseSelectStockPersonal'
import { RootState } from '../../../../shared/Infraestructure/AdapterStore'
import { iAutoInventario } from '../../shared/domain/iAutoInventario'
import { Repository } from '../infraestructure/repository'

export class UseCaseSelect {

  private repository: Repository
  private state: RootState

  constructor(repository: Repository, state: RootState) {
    this.repository = repository
    this.state = state
  }

  async exec(data: DtoResponseSelectStockPersonal[]) {
    return await this._exec(data)
  }

  private async _exec(data: DtoResponseSelectStockPersonal[]) {
    if (!this.state.generico.autoInventario) {
      return await this.consultarDataAutoinventario(data)
    }
    return this.generarDataAutoInventario(data)
  }

  private async consultarDataAutoinventario(data: DtoResponseSelectStockPersonal[]) {

    const IDS_StockPersonal = data.map(e => e.ID_StockPersonal)

    return await this.repository.find({
      filter: [
        { $match: { ID_StockPersonal: { $in: IDS_StockPersonal } } }
      ],
      fields: {
        Codigo: this.state.auth.user.Delegacion.Codigo,
        Nombre: this.state.auth.user.Pais.Nombre,
      },
      limit: null,
      skip: null,
      sort: null
    })

  }

  private generarDataAutoInventario(dataStockPersonal: DtoResponseSelectStockPersonal[]) {

    const data: iAutoInventario[] = []

    const KeyFecha = GetCodigoFechaActual()
    dataStockPersonal.forEach(e => {
      let stock = e.Despacho - e.Devolucion - e.Liquidacion + e.DespachoTR - e.DevolucionTR
      const precision = 1e-10
      stock = Math.abs(stock) < precision ? 0 : stock
      const newItem: iAutoInventario = {
        ID_StockPersonal: e.ID_StockPersonal,
        KeyFecha,
        Codigo: `${e.ID_StockPersonal}_${KeyFecha}`,
        Observacion: 'Confirmado',
        Cantidad: Number(stock.toFixed(2)),
        Stock: Number(stock.toFixed(2)),
        Estado: { ID_Estado: 2, Nombre: 'VALIDADO' },
        Identificacion: e.Personal.Identificacion,
        Ind_SB: e.Item.Ind_SB,
        CodigoLlave: e.CodigoLlave,
        CodigoBusqueda: e.CodigoBusqueda,
        Fecha: new Date().toISOString(),
        Equipos: [],
        Files: [],
        ID_AutoInventario: 0,
      }
      data.push(newItem)
    })

    return data

  }

}